<!-- <div class="scroll"> -->
    <section class="home-first" id="crypt">
        <div class="container">
            <div class="block b-cryptmi">
                <img src-tmp="./assets/img/cryptmi/logo-cryptmi.svg" alt="">
                <h4>Empower life with <br> simplicity</h4>
                <button class="btn" pageScroll href="#cryptmi" [routerLink]="['/cryptmi']" (click)="Navigate(cryptmi)">Learn more</button>
            </div>
            <div class="block">
                <h3>CYMi Token</h3>
                <h4>Connect to a world <br> of possibilities</h4>
                <button class="btn" pageScroll href="#cymipage" [routerLink]="['/cymi']">Learn more</button>
            </div>
        </div>
    </section>
    <section class="home-zero" id="cryptmi-zero" #cryptmi>
        <div class="tabs" [ngClass]="{'fixed': fixed}">
            <div class="cryptmi active" (click)="Navigate(cryptmi)" [routerLink]="['/cryptmi']" [routerLinkActive]="['active']">
                <img src-tmp="./assets/img/cryptmi/logo-cryptmi.svg" alt="">
            </div>
            <div class="cymi" pageScroll href="#cymipage" [routerLink]="['/cymi']" [routerLinkActive]="['active']">
                <img src-tmp="./assets/img/cryptmi/logo-cymi-w.png" alt="">
            </div>
        </div>
        <div class="content" *ngIf="hash && hash == '#/cryptmi'">
            <h1>Empower life with simplicity</h1>
            <span>Connect your rewards, crypto, and bank cards to buy all the things you love, anywhere in the world.
            </span>
            <button class="btn" (click)="openVideo('1')">Watch video</button>
        </div>
        <div class="filter"></div>
        <video id="video-1-cryptmi" *ngIf="!itsMobile" loop="loop" playsinline="" oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="./assets/img/cryptmi/bg-poster.png">
            <source
                src="https://player.vimeo.com/progressive_redirect/playback/597805071/rendition/720p/file.mp4?loc=external&signature=5cc558a0fe9006e030607885967785150dd17aca1fffa7863549016b283bdbc7"
                type="video/mp4">
        </video>
    </section>
    <section class="section home-one">
        <div class="container">
            <h2>Bring up your lifestyle with<br> more spending power.</h2>
            <div class="alinear-izquierda">
                <img src-tmp="./assets/img/cryptmi/empowered.webp" alt="">
            </div>
            <div class="alinear-derecha">
                <p>Download, register and start transferring your digital assets into <strong>cryptMi</strong>. Get ready to
                    spend and earn with more freedom than ever before.</p>
                <button class="btn" (click)="openVideo('2')">See the experience </button>
                <span>Download now!</span>
                <div class="stores">
                        <a href="https://play.google.com/store/apps/details?id=com.milesblue.milesblue" target="_blank">
                            <img src-tmp="./assets/img/cryptmi/store-google.webp" alt="">
                        </a>
                        <a href="https://apps.apple.com/us/app/cryptmiapp/id1586988515" target="_blank">
                            <img src-tmp="./assets/img/cryptmi/store-apple.webp" alt="">
                        </a>
                </div>
            </div>
        </div>
    </section>
    <section class="section home-one-m">
        <div class="container">
            <div class="tittle">
                <h2>Introducing Miles Digital Card:</h2>
                <span><strong>The world’s first dynamic card</strong> that allows you to blend all your digital assets to pay for everyday essentials, NFTs and purchases in the metaverse, by making dynamic and instant swaps between rewards, crypto and local currencies.</span>
            </div>
            <div class="alinear-derecha">
                <p><strong>The world’s first dynamic card</strong> that allows you to blend all your digital assets to pay for everyday essentials, NFTs and purchases in the metaverse, by making dynamic and instant swaps between rewards, crypto and local currencies.
                </p>
                <button class="btn" (click)="openVideo('7')">Watch video</button>
                <p>Add <strong>Miles Digital Card</strong> to your favorite <span>e-wallet</span></p>
                <img src-tmp="./assets/img/cryptmi/logo-pay.webp" alt="">
            </div>
            <div class="alinear-izquierda">
                <div>
                    <img  src="./assets/img/cryptmi/big-phone-right.webp" alt="">
                    <img  class="gif"  src="./assets/img/cryptmi/gif-card-right.gif" alt="">
                </div>
            </div>
            <!-- <a class="btn btn-discover" href="https://cryptmi.com/#/cryptMi-card" target="_blank">Discover the Miles Card </a> -->
        </div>
    </section>
    <section class="section home-two">
        <div class="container">
            <div class="alinear-izquierda"></div>
            <div class="alinear-derecha">
                <h2>Imagine all <br>
                    of what you<br>
                    own coming<br> together as one.
                </h2>
                <p>Instantly transfer your rewards, bank cards or cryptocurrencies into <strong>cryptMi</strong>, by
                    selecting the asset category and entering the amount you want to convert.</p>
            </div>
        </div>
    </section>
    <section class="section home-tabs">
        <h3>Bring 'em on! Here's all the assets<br> you can transfer to cryptMi.</h3>
        <div class="container">
            <app-tabs (outputEmiter)="pauseAllVideos($event)" (numberEmiter)="openVideo($event)"></app-tabs>
        </div>
    </section>
    <section class="section home-four">
        <div class="container">
            <div class="tittle">
                <h1>The lifestyle of your future begins today.</h1>
                <p>Enter all the experiences and things you love the most, without any limits or barriers. </p>
                <span>The universe is yours. <strong>The metaverse too</strong>.</span>
            </div>
            <!-- <a class="btn no-margin" href="https://cryptmi.com/#/home" target="_blank">cryptMi in </a> -->
        </div>
    </section>
    <section class="card-five home-five">
          <owl-carousel [options]="SlideOptions" [carouselClasses]="['owl-theme', 'sliding', 'timeout', 'speed']">
              <section class="item item-1">
                  <div class="container">
                      <div class="bl">
                        <h1>Ready to <br> dip your toe <br> into NFTs?</h1>
                        <p>Buy NFTs within the <strong>cryptMi</strong> app from Opensea, Coinbase or any NFT marketplace.</p>
                          <div class="logos">
                              <img class="img-opensea" src-tmp="./assets/img/cryptmi/logo-opensea.webp" alt="">
                              <img class="img-coinbase" src-tmp="./assets/img/cryptmi/logo-coinbase.svg" alt="">
                          </div>
                <button class="btn" (click)="openVideo('4')">See how it works</button>
                      </div>
                  </div>
              </section>
              <section class="item item-2">
                  <div class="container">
                      <div class="bl">
                        <h1>The <br> metaverse is <br> yours, too!</h1>
                        <p>Search, find and buy lands, <br> avatars or anything in the <br> metaverse with
                            <strong>cryptMi</strong>.</p>
                          <div class="logos">
                              <img src-tmp="./assets/img/cryptmi/logo-minecraft.svg" alt="">
                              <img src-tmp="./assets/img/cryptmi/logo-sandbox.svg" alt="">
                              <img src-tmp="./assets/img/cryptmi/logo-decentra.svg" alt="">
                          </div>
                <button class="btn" (click)="openVideo('5')">See how it works</button>
                      </div>
                  </div>
              </section>
              <section class="item item-3">
                  <div class="container">
                      <div class="bl">
                        <h1>Travel like <br> there’s no <br> tomorrow</h1>
                        <p>Combine <strong>cryptMi</strong> with over 400 airline loyalty programs and more tan 150 hotel
                            rewards programs. Get best-in-class benefits when you book, all included in your <strong>Miles Card</strong>.</p>
                      </div>
                  </div>
                  <div class="slide-cripto">
                      <div class="animate">
                          <img src-tmp="./assets/img/cryptmi/scroll-travel2.svg" alt="">
                      </div>
                      <div class="animate2">
                          <img src-tmp="./assets/img/cryptmi/scroll-hotels2.svg" alt="">
                      </div>
                  </div>
            <button class="btn" (click)="openVideo('6')">See how it works</button>
              </section>
              <section class="item item-4">
                <div class="container">
                    <div class="bl">
                        <h1>Shop like<br>there are no<br>frontiers</h1>
                        <p>Shop at <strong>over 100 million stores around the world</strong>, online and in store via contactless payments, all within the <strong>cryptMi app</strong>.</p>
                        <div class="logos-2">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-amazon.webp" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-apple.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-beyond.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-costco.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-macys.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-samsung.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-netflix.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-ebay.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-forever.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-zappos.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-jc.png" alt="">
                            <img src-tmp="./assets/img/cryptmi/shop/logo-walmart.png" alt="">
                        </div>
                        <button class="btn" (click)="openVideo('9')">See how it works</button>
                    </div>
                </div>
            </section>
          </owl-carousel>
    </section>
        <div class="bg-video content" [ngClass]="{'open': video1}" *ngIf="hash && hash == '#/cryptmi'">
            <div class="full-video content-video">
                <video id="video-2-cryptmi" class="main-video" controls preload="none">
                    <source
                        src-tmp="https://player.vimeo.com/progressive_redirect/playback/708795449/rendition/540p/file.mp4?loc=external&signature=fab1103da4cad90cd99a4982fb3ecfbbf21b30b122db0e388f3c317f01e9fd88"
                        type="video/mp4">
                </video>
            </div>
            <span class="icon-close" (click)="closeVideo('1')"></span>
        </div>
        <div class="bg-video content" [ngClass]="{'open': video2}" *ngIf="hash && hash == '#/cryptmi'">
            <div class="full-video content-video">
                <video id="video-2-cryptmi" class="video-two" controls  preload="none">
                    <source
                        src-tmp="https://player.vimeo.com/progressive_redirect/playback/708795574/rendition/540p/file.mp4?loc=external&signature=eb11d3a4d08814114ba35c78e81aec16c7842f593fcc850c732f4343e2287e6f"
                        type="video/mp4">
                </video>
            </div>
            <span class="icon-close" (click)="closeVideo('2')"></span>
        </div>
        <div class="bg-video close-web" [ngClass]="{'open': video7}">
            <div class="modal-general">
                <div class="bl-modal bl-modal--columns">
                    <div class="">
                    </div>
                    <div class="bl-modal__text">
                        <span>Add Miles Digital Card to your e-wallet. It's simple.</span>
                        <ul class="bl-modal__list">
                            <li><span>1</span> <p>Go to <strong>“My Wallet”</strong> on the main menu.</p></li>
                            <li><span>2</span> <p>Tap on the <span class="icon-card"></span> icon to see your <strong>Miles Digital Card</strong> information</p></li>
                            <li><span>3</span> <p>Copy your card information</p></li>
                            <li><span>4</span> <p>Open your e-wallet and paste the information</p></li>
                            <li><span>5</span> <p>Accept Terms and Conditions</p></li>
                        </ul>
                        <p><strong>That’s it! Your Miles Digital Card has been added.</strong></p>
                    </div>
                    <div class="bl-modal__video" *ngIf="hash && hash == '#/cryptmi'">
                        <div class="phone">
                            <div class="content">
                                <video id="video-3-cryptmi" class="video-card" loop="loop" onloadedmetadata="this.muted = true" playsinline="" poster="" preload="none">
                                    <source
                                        src-tmp="https://player.vimeo.com/progressive_redirect/playback/708795656/rendition/540p/file.mp4?loc=external&signature=7b1a4be2075d8e5532277a2699c0c57582ed748c97661bd67d25f9cb97c71f1f" type="video/mp4">
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span class="icon-close" (click)="closeVideo('7')"></span>
        </div>
    <div class="bg-video close-web" [ngClass]="{'open': video8}">
        <div class="modal-general">
          <div class="bl-modal bl-modal--columns">
            <div class="">
            </div>
            <div class="bl-modal__text">
              <span>How to add a bank card to the cryptMi wallet</span>
              <ul class="bl-modal__list">
                <li><span>1</span> <p>Go to “<strong>My Wallet</strong>” on the main menu.</p></li>
                <li><span>2</span> <p>Touch the <span class="icon-card icon-card--blue"></span> symbol to add your credit or debit cards
                </p></li>
                <li><span>3</span> <p>Enter your card information manually or scan your card from the camera to autofill.</p></li>
                <li><span>4</span> <p>Tap on “<strong>Save card</strong>”.</p></li>
              </ul>
              <p><strong>You're all set</strong>, you just added your first card on <strong>cryptMi!</strong></p>
            </div>
            <div class="bl-modal__video" *ngIf="hash && hash == '#/cryptmi'">
              <div class="phone">
                <div class="content">
                  <video id="video-4-cryptmi" class="video-bank-card" loop="loop" onloadedmetadata="this.muted = true" playsinline="" poster="" preload="none">
                    <source
                      src-tmp="https://player.vimeo.com/progressive_redirect/playback/708796069/rendition/540p/file.mp4?loc=external&signature=a1e6661d5cc3f266b93ba70063347126b4365394c74d5cbd4af1efbf99c8bb7d"
                      type="video/mp4">
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="icon-close" (click)="closeVideo('8')"></span>
    </div>
    <!--start modals slider caorusel-->
    <div class="bg-video close-web" [ngClass]="{'open': video4}">
        <div class="modal-general">
            <div class="bl-modal bl-modal--columns">
                <div class="">
                </div>
                <div class="bl-modal__text">
                    <ul class="bl-modal__list">
                        <li><span>1</span> <p>Log in to the <strong>cryptMi</strong> app</p></li>
                        <li><span>2</span> <p>Type the name of the store in the main menu search engine, or select the NFTs category. NOTE: This video features OpenSea as an example, but the step-by-step is the same for any other NTF marketplace.</p></li>
                        <li><span>3</span> <p>Browse the selected store and choose the NFT you want</p></li>
                        <li><span>4</span> <p>Tap on the <strong>“Connect”</strong> button, select the cryptocurrency and the amount to be charged to your external crypto-wallet</p></li>
                        <li><span>5</span> <p>Open your external crypto-wallet, choose the <strong>"Receive"</strong> option for the same crypto coin, then copy the auto generated link</p></li>
                        <li><span>6</span> <p>Go back to step 4 within <strong>cryptMi</strong> to paste the address.</p></li>
                        <li><span>7</span> <p>Tap the <strong>“Continue”</strong> button to confirm the crypto coin recharge to your external wallet.</p></li>
                        <li class="item-last"><p><strong>Your crypto wallet has been loaded</strong>, so you can now complete your NFT purchase!</p></li>
                    </ul>
                </div>
                <div class="bl-modal__video" *ngIf="hash && hash == '#/cryptmi'">
                    <div class="phone">
                        <div class="content">
                            <video id="video-5-cryptmi" class="video-nft" loop="loop" onloadedmetadata="this.muted = true" playsinline="" poster="" preload="none">
                                <source
                                src-tmp="https://player.vimeo.com/progressive_redirect/playback/708796744/rendition/540p/file.mp4?loc=external&signature=bcfff9fdc9017a5c9ecfafd40d1d528b5974f322cef460b0837eac8a7547e001"
                                type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span class="icon-close" (click)="closeVideo('4')"></span>
    </div>
    <div class="bg-video close-web" [ngClass]="{'open': video5}">
        <div class="modal-general">
            <div class="bl-modal bl-modal--columns">
                <div class="">
                </div>
                <div class="bl-modal__text">
                    <ul class="bl-modal__list">
                        <li><span>1</span> <p>Log in to <strong>cryptMi</strong></p></li>
                        <li><span>2</span> <p>Type the name of the store in the main menu search engine, or select the Metaverse category </p></li>
                        <li><span>3</span> <p>Explore the selected marketplace and choose the gadget you want to purchase</p></li>
                        <li><span>4</span> <p>Touch the <strong>“Connect”</strong> button, select the cryptocurrency and the value to recharge in your external crypto wallet</p></li>
                        <li><span>5</span> <p>Open your external crypto wallet, select the <strong>“Receive”</strong> option and the same cryptocurrency, and then copy the address that will be auto-generated</p></li>
                        <li><span>6</span> <p>Go back to step 4 within <strong>cryptMi</strong> to paste the address</p></li>
                        <li><span>7</span> <p>Tap the <strong>“Continue”</strong> button to confirm the crypto coin recharge to your external wallet</p></li>
                        <li class="item-last"><p><strong>Your crypto wallet has been loaded</strong>, so you can now complete your purchase in the metaverse. </p></li>
                    </ul>
                </div>
                <div class="bl-modal__video" *ngIf="hash && hash == '#/cryptmi'">
                    <div class="phone">
                        <div class="content">
                            <video id="video-6-cryptmi" class="video-metaverse" loop="loop" onloadedmetadata="this.muted = true" playsinline="" poster="" preload="none">
                                <source
                                src-tmp="https://player.vimeo.com/progressive_redirect/playback/709268505/rendition/540p/file.mp4?loc=external&signature=7f7ce20d177564c28d680689afd112dcdb72ad39ca943fc8de979e2c23035eb8"
                                type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span class="icon-close" (click)="closeVideo('5')"></span>
    </div>
    <div class="bg-video close-web" [ngClass]="{'open': video6}">
        <div class="modal-general">
            <div class="bl-modal bl-modal--columns">
                <div class="">
                </div>
                <div class="bl-modal__text">
                    <ul class="bl-modal__list">
                        <li><span>1</span> <p>Log in to the <strong>cryptMi</strong></p></li>
                        <li><span>2</span> <p>Type the <strong>“Expedia”</strong> name in the main menu search engine or select the Travel category</p></li>
                        <li><span>3</span> <p>Enter your data in the Expedia search fields according to the product you want (flights, hotels, car rental or others) and touch the "Search" button</p></li>
                        <li><span>4</span> <p>Select the option that best suits your travel plan and press the <strong>“Check out”</strong> button</p></li>
                        <li><span>5</span> <p>Tap on <strong>“Connect”</strong> to pay with your cryptMi card and enter the total amount of the purchase</p></li>
                        <li><span>6</span> <p>Press <strong>“Continue”</strong> and copy your <strong>Miles Digital Card</strong> information in the checkout form</p></li>
                        <li><span>7</span> <p>Complete your reservation by tapping the <strong>“Complete Booking”</strong> button.</p></li>
                        <li class="item-last"><p>You can now pack your bags! And the best part? You earn up to <strong>5X upperMiles</strong>.  </p></li>
                    </ul>
                </div>
                <div class="bl-modal__video" *ngIf="hash && hash == '#/cryptmi'">
                    <div class="phone">
                        <div class="content">
                            <video id="video-7-cryptmi"  class="video-travel" loop="loop" onloadedmetadata="this.muted = true" playsinline="" poster="" preload="none">
                                <source
                                src-tmp="https://player.vimeo.com/progressive_redirect/playback/708796680/rendition/1080p/file.mp4?loc=external&signature=bd414ccc9deb217ef3c14fe36830eb8584f096b08c8123822595d4ad823fb23c"
                                type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span class="icon-close" (click)="closeVideo('6')"></span>
    </div>
    <div class="bg-video close-web" [ngClass]="{'open': video9}">
        <div class="modal-general">
            <div class="bl-modal bl-modal--columns">
                <div class="">
                </div>
                <div class="bl-modal__text">
                    <h3>Shop the best Amazon deals!</h3>
                    <ul class="bl-modal__list">
                        <li><span>1</span> <p>Log in to the <strong>cryptMi</strong></p></li>
                        <li><span>2</span> <p>Type <strong>“Amazon”</strong> in the main menu search engine or select the Department Stores category</p></li>
                        <li><span>3</span> <p>Select your product and add it to the shopping cart</p></li>
                        <li><span>4</span> <p>Touch the <strong>“Connect”</strong> button at checkout to pay with your Miles Card and enter the total value of the purchase</p></li>
                        <li><span>5</span> <p>Tap on the <strong>"Continue"</strong> button to view your <strong>Miles Card</strong> data. Copy and paste the information into the checkout form.</p></li>
                        <li class="item-last"><p><strong>Well done!</strong> Your purchase has been completed.</p></li>
                    </ul>
                </div>
                <div class="bl-modal__video" *ngIf="hash && hash == '#/cryptmi'">
                    <div class="phone">
                        <div class="content">
                            <video id="video-8-cryptmi" class="video-shop" loop="loop" onloadedmetadata="this.muted = true" playsinline="" poster="" preload="none">
                                <source
                                    src-tmp="https://player.vimeo.com/progressive_redirect/playback/717509559/rendition/1080p/file.mp4?loc=external&signature=16722eaba88c8362a396d6cac4100823e000c48c402984ef172f28d9b0a20feb"
                                    type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span class="icon-close" (click)="closeVideo('9')"></span>
    </div>
    <!--end modals slider caorusel-->
    <!-- <section class="after">
    </section> -->
    <app-footer></app-footer>